<template>
	<div class="order-modal-candidate__content">
		<div
			:class="{ 'order-modal-candidate__filter-section--opened' : setup.filterOpened }"
			class="order-modal-candidate__filter-section">
			<span
				class="order-modal-candidate__filter-section-close"
				@click="setup.filterOpened = false"/>
			<div id="orderModalFilter"/>
		</div>

		<div
			ref="listSection"
			class="order-modal-candidate__candidate-section">
			<temp-worker-paged-list-view
				:order="order"
				:filter-props="filterProps"
				:list-footer-actions="listFooterActions"
				in-modal
				@add-candidates="$emit('addCandidates')"/>
		</div>
	</div>
</template>

<script setup lang="ts">
import OrderModalCandidateSetupService from '@/setup/order/OrderModalCandidateSetupService';
import TempWorkerPagedListView from '@/components/temp-worker/TempWorkerPagedListView.vue';
defineEmits<{(e: 'addCandidates'): void}>();
const props = defineProps(OrderModalCandidateSetupService.props);
const setup = new OrderModalCandidateSetupService(props);
</script>

<style lang="less">
@maxWidth: calc(100vw - 2.5rem);
@widthCustom: calc(1520rem / 16);

.order-modal-candidate {
  width: min(@widthCustom, @maxWidth);
  left: max(calc(50% - @widthCustom / 2), calc(50% - @maxWidth / 2));
  overflow-x: hidden;

	.orion-modal__body {
		padding: 0;
		background-color: var(--grey-lighter);
		background: var(--grey-lighter);
	}

  .orion-modal__close {
    z-index: 1;
  }

	.orion-section__content {
		margin-top: 0rem;
	}
}
</style>

<style lang="less" scoped>
@import '@/styles/variables.less';
@import '@/styles/mixins.less';

.order-modal-candidate {
	&__content {
		display: flex;
		height: calc(100vh - 8rem);
		height: calc(100dvh - 8rem);
		flex-direction: column;

		@media @tabletLandscape {
			flex-direction: row;
		}
	}

  &__title {
    font-size: 1rem;
    color: var(--grey-darker);
    font-weight: 600;
    line-height: 2.5rem;
    margin-bottom: 1.25rem;
  }

  &__filter-section {
		position: absolute;
    top: 0;
    right: 0;
		z-index: 13;
		height: 100%;
    width: var(--arm-aside-width);
    padding: 2rem;
		overflow: auto;
		overflow-x: hidden;
		background: white;
		transition: transform .4s, box-shadow .3s;
		box-shadow: -0.5rem 0 1.25rem fade(black, 10);
    transform: translate3d(100%, 0, 0);

		@media @tabletLandscape {
      transition: none;
      transform: none;
      position: sticky;
      flex: 0 0 var(--arm-aside-width);
      box-shadow: 0.5rem 0 1.25rem fade(black, 10);
		}

		&--opened {
			transform: translate3d(0, 0, 0);
			// overflow: hidden;
		}
  }

	&__filter-section-close {
		.close(1.5rem);
		position: absolute;
		top: 1rem;
		right: 1rem;

		@media @tabletLandscape {
			display: none;
		}
	}

	&__filter-section-actions {
		margin: 0 -1.9rem -1.9rem -1.9rem;
		padding: 0.9rem 1.9rem 1.9rem;
		position: sticky;
		bottom: -1.9rem;
		background: white;
		z-index: 1;
		box-shadow: 0 0 0.6rem var(--grey-light);
	}

  &__candidate-section {
		position: relative;
    padding: 3rem 2rem 0;
		width: 100%;
    overflow: auto;
    display: flex;
    flex-direction: column;

    :deep(.orion-footer-fixed) {
      position: sticky;
      margin: auto -2rem 0;
      bottom: 0;
    }

    :deep(.orion-page) {
      width: 100%;
      display: flex;
      flex-direction: column;

      &__content {
        flex: 1;
        display: flex;
        flex-direction: column;

        .orion-list {
          flex: 1;
          display: flex;
          flex-direction: column;
        }
      }
    }
  }

	&__loader {
		z-index: 2;
	}

  :deep(&__filter-trigger) {
    @media @tabletLandscape {
      display: none;
    }
  }
}

:deep(.filter-section__actions) {
  position: sticky;
  bottom: -2rem;
  z-index: 1;
  margin: auto -2rem -2rem;
  padding: 2rem;
  background: white;
  box-shadow: 0 0 0.6rem var(--grey-light);

  .orion-section__content {
    display: flex;
    flex-direction: column;;
    align-items: stretch;
  }
}

#orderModalFilter {
  display: flex;
  flex-direction: column;
  height: 100%;

  :deep(.paged-list-filter) {
    display: flex;
    flex-direction: column;
    height: 100%;

    > .filter-section__actions {
      margin-top: auto;
    }
  }
}
</style>
